import type { ReactNode } from "react"

import { HelpProvider } from "@/components/help"
import { Toaster } from "@/components/ui/sonner"
import { useAnalytics } from "@/hooks/use-analytics"
import { useFlash } from "@/hooks/use-flash"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useAnalytics()
  useFlash()
  return (
    <HelpProvider>
      {children}
      <Toaster />
    </HelpProvider>
  )
}
